/**
 * ce-v2-launch.js — Shared v2 Customizer launch helper
 *
 * Exposes:
 *   window.ceBuildCustomizerLaunchUrl(input)  → URL string
 *   window.ceNavigateToCustomizer(input)      → navigates browser
 */
(function () {
  'use strict';

  var MARKETING_PARAMS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'
  ];

  function getMarketingParams() {
    var params = [];
    try {
      var sp = new URLSearchParams(window.location.search);
      for (var i = 0; i < MARKETING_PARAMS.length; i++) {
        var key = MARKETING_PARAMS[i];
        if (sp.has(key)) {
          params.push(encodeURIComponent(key) + '=' + encodeURIComponent(sp.get(key)));
        }
      }
    } catch (e) { /* old browsers */ }
    return params;
  }

  /**
   * @param {Object} input
   * @param {string}  input.launchBase        - v2 launch base URL
   * @param {string}  input.shopDomain        - shop.permanent_domain
   * @param {number|null} input.variantId     - resolved variant ID
   * @param {number|null} input.productId     - product ID
   * @param {string}  input.productHandle     - product handle
   * @param {string|null} input.productSpecSlug - customized.product_spec_slug
   * @param {boolean} input.useLegacy         - ce_rebrand.use_legacy_customizer
   * @returns {string} URL
   */
  function buildUrl(input) {
    /* Legacy path */
    if (input.useLegacy) {
      var legacyParams = ['legacy=1'];
      if (input.variantId) {
        legacyParams.push('variant_id=' + encodeURIComponent(input.variantId));
      } else if (input.productId) {
        legacyParams.push('product_id=' + encodeURIComponent(input.productId));
      }
      return '/pages/customize?' + legacyParams.join('&');
    }

    /* v2 path */
    var base = input.launchBase || 'https://app.customenvy.com/customize/launch';
    var parts = [];

    parts.push('shop=' + encodeURIComponent(input.shopDomain || ''));

    if (input.variantId) {
      parts.push('variant_id=' + encodeURIComponent(input.variantId));
    }
    if (input.productId) {
      parts.push('product_id=' + encodeURIComponent(input.productId));
    }
    if (input.productHandle) {
      parts.push('product_handle=' + encodeURIComponent(input.productHandle));
    }
    if (input.productSpecSlug) {
      parts.push('slug=' + encodeURIComponent(input.productSpecSlug));
      parts.push('handle_fallback=0');
    } else {
      parts.push('handle_fallback=1');
    }

    parts.push('storefront_url=' + encodeURIComponent(window.location.href));

    /* Marketing params passthrough */
    var mktg = getMarketingParams();
    for (var i = 0; i < mktg.length; i++) {
      parts.push(mktg[i]);
    }

    var sep = base.indexOf('?') === -1 ? '?' : '&';
    return base + sep + parts.join('&');
  }

  function navigate(input) {
    window.location.href = buildUrl(input);
  }

  window.ceBuildCustomizerLaunchUrl = buildUrl;
  window.ceNavigateToCustomizer = navigate;
})();
